<div id="content" class="allcp-form" ng-controller="StockStoreController" ng-init="new()">
	<div ng-include="'modules/company/menus/stock_menu.html'"></div>
	<div class="row mt20">
		<div class="panel">

			<div class="panel-heading">
				<span class="panel-title"> Depo Ekle</span>
				<hr>
			</div>
			<div class="panel-body pn">
				<div class="col-md-7">
					<form ng-submit="save()" class="form-horizontal allcp-form">
					
						<div class="form-group">
							<label class="col-md-3 control-label">
								Depo Adı * 
							</label>
							<div class="col-md-9">
								<label for="name21" class="field prepend-icon">
									<input type="text" ng-model="stockStore.name" class="gui-input br-light light" placeholder="Depo Adı" required>
									<label for="name21" class="field-icon">
										<i class="fa fa-list-alt"></i>
									</label>
								</label>
							</div>
						</div>

						<div class="form-group">
							<label class="col-md-3 control-label">
								Bağlı Olduğu Proje * 
							</label>
							<div class="col-md-9">
								<label for="name21" class="field">
									<select
										class="gui-input form-control"
										ng-options="option.id as option.name for option in data.fieldProjects track by option.id"
										ng-model="stockStore.field_projects_id"
									>
									<option value="">Seçim Yapınız</option>
									</select>
								</label>
							</div>
						</div>

						<div class="form-group">
							<label class="col-md-3 control-label">
								Bağlı Olduğu Müşteri * 
							</label>
							<div class="col-md-9">
								<div angucomplete-alt
									name="stockStore"
									ng-model="stockStore.company_customer"
									placeholder="Müşteri Adı"
									pause="100"
									selected-object="customerSelect"
									remote-url="api/find-customer?s="
									remote-url-data-field="customers"
									search-fields="customer_name,phone_number,address"
									title-field="customer_name"
									description-field="address"
									minlength="1"
									input-class="form-control input-md"
									match-class="highlight"
									>
								</div>
							</div>
						</div>

						<div class="form-group">
							<label class="col-md-3 control-label">
								Bağlı Olduğu Personel * 
							</label>
							<div class="col-md-9">
								<label for="name21" class="field">
									<select
										class="gui-input form-control"
										ng-options="option.id as option.full_name for option in data.workers track by option.id"
										ng-model="stockStore.worker_id"
									>
									<option value="">Seçim Yapınız</option>
									</select>
								</label>
							</div>
						</div>

						<div class="form-group">
							<label class="col-md-3 control-label">
								Açıklama * 
							</label>
							<div class="col-md-9">
								<label for="name21" class="field prepend-icon">
									<textarea ng-model="stockStore.description" class="form-control" placeholder="Açıklama" required cols="30" rows="5"></textarea>
									<label for="name21" class="field-icon">
										<i class="fa fa-list-alt"></i>
									</label>
								</label>
							</div>
						</div>

						<div class="form-group">
							<div class="col-md-12">
								<button type="submit" class="btn btn-primary pull-right"><span class="fa fa-save"></span> Kaydet</a>
							</div>
						</div>

					</form>
				</div>
			</div>
		</div>
	</div>
</div>
